import { useSelector } from 'react-redux'
import { useExportResourceModal } from 'components/modals/common/ExportResourceModal/hooks'
import { useModal } from 'hooks'
import { getFileName } from 'utils/sheet'
import { getOrm } from 'orm/selectors'

export const useExportJobsData = () => {
  const { projects } = useSelector(getOrm)

  const fileName = getFileName('jobs')

  const pks = Object.keys(projects?.meta?.selected ?? {})
  const fields = [
    'name',
    'description',
    'candidates_count',
    'languages',
    'start_date',
    'end_date',
  ]
  const items = projects?.items ?? {}
  const data = pks
    .filter(pk => Object.prototype.hasOwnProperty.call(items, pk))
    .map(pk => {
      const item = items[pk]
      return Object.fromEntries(
        fields
          .filter(field => item != null && field in item)
          .map(field => [field, item[field]]),
      )
    })

  const { handleExportFile } = useExportResourceModal({ data })

  const handleExportCSV = handleExportFile(`${fileName}.csv`)

  const handleExportXLXS = handleExportFile(`${fileName}.xlsx`)

  return {
    state: { data },
    handlers: { handleExportCSV, handleExportXLXS },
  }
}

export const useExportJobsModal = () => {
  const { handleClose, handleOpen, isOpen } = useModal()

  return {
    handleExportJobsModalClose: handleClose,
    handleExportJobsModalOpen: handleOpen,
    isExportJobsModalOpen: isOpen,
  }
}
